import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/smanga-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-316229a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "init" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  })
], -1 /* HOISTED */))
const _hoisted_4 = { class: "middle" }
const _hoisted_5 = { class: "middle-content" }
const _hoisted_6 = { class: "bottom" }
const _hoisted_7 = { class: "bottom-content" }
const _hoisted_8 = { class: "btn-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: _normalizeClass(['title', $setup.setps[$setup.active].titlestate])
      }, _toDisplayString($setup.setps[$setup.active].titleText), 3 /* TEXT, CLASS */)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createCommentVNode(" 数据库设置 "),
        ($setup.active === 0)
          ? (_openBlock(), _createBlock($setup["database"], {
              key: 0,
              onUpdate: $setup.update_database_view
            }))
          : _createCommentVNode("v-if", true),
        ($setup.active === 1)
          ? (_openBlock(), _createBlock($setup["newUser"], {
              key: 1,
              onUpdate: $setup.update_user_view
            }))
          : _createCommentVNode("v-if", true),
        ($setup.active === 2)
          ? (_openBlock(), _createBlock($setup["databaseUpdate"], {
              key: 2,
              onUpdate: $setup.update_system_view,
              userName: $setup.userName,
              passWord: $setup.passWord
            }, null, 8 /* PROPS */, ["userName", "passWord"]))
          : _createCommentVNode("v-if", true),
        ($setup.active === 3)
          ? (_openBlock(), _createBlock($setup["result"], { key: 3 }))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        ($setup.isPhone)
          ? (_openBlock(), _createBlock(_component_el_steps, {
              key: 0,
              active: $setup.active,
              "align-center": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_step, { title: "数据库" }),
                _createVNode(_component_el_step, { title: "新建用户" }),
                _createVNode(_component_el_step, { title: "初始化" }),
                _createVNode(_component_el_step, { title: "完成" })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["active"]))
          : (_openBlock(), _createBlock(_component_el_steps, {
              key: 1,
              active: $setup.active,
              "align-center": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_step, {
                  title: "数据库",
                  description: "设置数据库链接"
                }),
                _createVNode(_component_el_step, {
                  title: "新建用户",
                  description: "新建用户"
                }),
                _createVNode(_component_el_step, {
                  title: "初始化",
                  description: "数据库与环境升级"
                }),
                _createVNode(_component_el_step, {
                  title: "完成",
                  description: "版本信息与注意事项"
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["active"])),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: $setup.before,
            loading: $setup.setps[$setup.active].btnLoading,
            disabled: $setup.setps[$setup.active].btnDisabled
          }, {
            default: _withCtx(() => [
              _createTextVNode("上一步")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["loading", "disabled"]),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: $setup.next,
            loading: $setup.setps[$setup.active].btnLoading,
            disabled: $setup.setps[$setup.active].btnDisabled
          }, {
            default: _withCtx(() => [
              _createTextVNode("下一步")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["loading", "disabled"])
        ])
      ])
    ])
  ]))
}